<template>
    <div class="dashboard_classification">
        <div class="main_div">
            <div class=" headerTop pb-5">
                <div class="header_section_header is-flex is-flex-direction-row">
                    <div>
                        <div class="header_title">Estado de resultados</div>
                        <div class="header_description mb-3">
                            Visualiza el estado de tu negocio en un solo lugar.
                        </div>
                        <div class="filter_container is-align-content-flex-end">
                            <SimpleButton @click="() => { this.filterPeriod = 'month'; }" class="select_button nobreak"
                                v-bind:class="{ black_button: filterPeriod === 'month' }">
                                Mensual
                            </SimpleButton>
                            <SimpleButton @click="() => { this.filterPeriod = 'quarter'; }"
                                class="select_button nobreak" v-bind:class="{
                                    black_button: filterPeriod === 'quarter',
                                }">
                                Trimestral
                            </SimpleButton>
                            <SimpleButton @click="() => { this.filterPeriod = 'ytd'; }" class="select_button nobreak"
                                v-bind:class="{ black_button: filterPeriod === 'ytd' }">
                                YTD
                            </SimpleButton>
                            <SimpleButton @click="() => { this.filterPeriod = 'year'; }" class="select_button nobreak"
                                v-bind:class="{ black_button: filterPeriod === 'year' }">
                                Anual
                            </SimpleButton>
                        </div>
                    </div>
                    <div class="is-align-content-flex-end mb-2">
                        <div class="is-flex">
                            <span class=" is-clickable">
                                <AnualCalendar class="calendar" v-model="endMonth" :disableNewerDates="true"
                                    :disabledFrom="getNow" formatLabelDate="MMMM YYYY"
                                    @onDateChange="(e) => changeDate(e)" />
                            </span>
                            <span class="theme_btn_white is-clickable ml-3">Exportar</span>
                        </div>

                    </div>
                </div>
            </div>

            <div class="underHeader mt-5 ">
                <div class="is-flex is-full-width has-gap-cards">
                    <CardResults class="is-flex-grow-1" tittleCard="Ventas"
                        :mainAmount="tableRowHeaders['ventas_netas']?.itemsDict[getHeadersTable()[getHeadersTable().length - 1]] ?? 0"
                        :mainDetail="allDetails[0]" tittleSection="Métricas" :sectionDetails="allSectionDetails[0]" />
                    <CardResults class="is-flex-grow-1" tittleCard="Costos"
                        :mainAmount="tableRowHeaders['costos_directos']?.itemsDict[getHeadersTable()[getHeadersTable().length - 1]] ?? 0"
                        :mainDetail="allDetails[1]" tittleSection="Costos más altos"
                        :sectionDetails="allSectionDetails[1]" />
                    <CardResults class="is-flex-grow-1" tittleCard="Gastos"
                        :mainAmount="tableRowHeaders['gastos_totales']?.itemsDict[getHeadersTable()[getHeadersTable().length - 1]] ?? 0"
                        :mainDetail="allDetails[2]" tittleSection="Gastos más altos"
                        :sectionDetails="allSectionDetails[2]" />
                    <CardResults class="is-flex-grow-1" tittleCard="EBITDA"
                        :mainAmount="tableRowHeaders['EBITDA']?.itemsDict[getHeadersTable()[getHeadersTable().length - 1]] ?? 0"
                        :mainDetail="allDetails[3]" tittleSection="Utilidades" :sectionDetails="allSectionDetails[3]" />
                </div>
                <div class="mt-6 p-4 container_section">
                    <p class="is-flex is-justify-content-space-between">
                        <span class="tittle_section">Estado de Resultados</span>
                        <span class="is-flex pb-3">
                            <span class="filter_section is-flex">Ver Gráfico</span>
                            <span v-if="!['ytd', 'anual'].includes(filterPeriod)" style="min-width: 165px">
                                <SelectComponent v-model="selectedPeriod" theme="report_theme" :weirdOptions="null"
                                    :options="periodTypes" />
                            </span>
                        </span>
                    </p>
                    <section>
                        <div ref="mainTable" class="table-container is-scrollable">
                            <table class="table is-narrow is-full-width custom_table">
                                <colgroup>
                                    <col style="width: 180px;">
                                    <col style="width: 180px;" v-for="header in getHeadersTable()" :key="header">
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th scope="col" class="sticky-column theme_row_header"></th>
                                        <th scope="col" class="theme_row_header" v-for="header in getHeadersTable()"
                                            :key="header">
                                            <span class="is-capitalized">
                                                {{ header }}
                                            </span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="key in allKeysOrdered" :key="key" :class="tableRowHeaders[key].theme">
                                        <template v-if="tableRowHeaders[key].isShowed ?? true">
                                            <th scope="row" class="sticky-column nobreak"
                                                :class="tableRowHeaders[key].theme ?? 'theme_row_white'">
                                                <span>
                                                    {{ tableRowHeaders[key].label }}
                                                </span>
                                                <span v-if="key == 'gastos_totales'" class="is-pulled-right"
                                                    @click="() => changeViewTotalBills()">
                                                    <ArrowDown class="actual_button_arrow_down color_arrow"
                                                        :class="{ rotate_arrow: totalBillsExpanded }" />
                                                </span>
                                            </th>
                                            <td v-for="(header) in getHeadersTable()"
                                                :key="header + tableRowHeaders[key].label"
                                                :class="tableRowHeaders[key].theme">
                                                <span class="nobreak" v-if="tableRowHeaders[key].isMoney">
                                                    {{ money(
                                                        tableRowHeaders[key].itemsDict[header] ?? 0
                                                    ) }}
                                                </span>
                                                <span class="nobreak" v-else>
                                                    {{
                                                        Math.round(tableRowHeaders[key].itemsDict[header] ?? 0)
                                                    }}%
                                                </span>
                                            </td>
                                        </template>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </section>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import AnualCalendar from "@/components/classification/AnualCalendar";
import SelectComponent from "@/components/classification/SelectComponent";
import CardResults from "@/components/financialReports/CardResults";
import SimpleButton from "@/components/modals/SimpleButton.vue";

import { getResultStateByPeriod } from '@/api/financialReport';
import ArrowDown from "@/components/svg/ArrowDown.vue";
import { parseToMoney } from "@/utils/currency";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/inter/900.css";
import moment from 'moment';

export default {
    name: "DashboardReports",
    components: {
        SimpleButton,
        CardResults,
        SelectComponent,
        AnualCalendar,
        ArrowDown
    },
    data() {
        return {
            totalBillsExpanded: false,
            endMonth: moment().toDate(),
            filterPeriod: 'month',// 'month', 'quarter', o 'year'
            allDetails: [{
                label: 'Crecimiento',
                value: '% MoM',
                theme: 'themePercentGreen',
                key: 'ventas_netas'
            }, {
                label: 'Margen Bruto',
                value: '%',
                theme: 'themePercentBlue',
                key: 'margen_bruto'
            }, {
                label: 'Eficiencia',
                value: '%',
                theme: 'themePercentOrange',
                key: 'gastos/ventas_%'
            }, {
                label: 'Margen EBITDA',
                value: '%',
                theme: 'themePercentPurple',
                key: 'margen_EBITDA_%'
            }],
            allSectionDetails: [
                [{
                    label: 'Ticket Promedio',
                    value: '$0',
                }, {
                    label: 'Cantidad de Clientes',
                    value: '0',
                }], [{
                    label: 'Cuenta',
                    value: '_',
                }, {
                    label: 'Contraparte',
                    value: '_',
                }], [{
                    label: 'Cuenta',
                    value: '_',
                }, {
                    label: 'Contraparte',
                    value: '_',
                }], [{
                    label: 'Antes de Impuestos',
                    value: '$0',
                }, {
                    label: 'Margen Neto %',
                    value: '0%',
                }],
            ],
            tableRowHeaders: {
                "ventas_netas": {
                    label: 'Ventas Netas',
                    isMoney: true,
                    keysSum: ['ventas_netas'],
                    itemsDict: [],
                },
                "costos_productos": {
                    label: 'Costos Productos',
                    isMoney: true,
                    keysSum: ['costos_productos'],
                    itemsDict: [],
                },
                "margen_producto": {
                    label: 'Margen Producto %',
                    isMoney: false,
                    theme: 'theme_row_blue',
                    keysSum: ['margen_producto'],
                    itemsDict: [],
                },
                "costos_variables": {
                    label: 'Costos Variables',
                    isMoney: true,
                    keysSum: ['costos_variables'],
                    itemsDict: [],
                },
                "costos_directos": {
                    label: 'Costos Directos',
                    isMoney: true,
                    keysSum: ['costos_directos'],
                    itemsDict: [],
                },
                "margen_bruto": {
                    label: 'Margen Bruto %',
                    isMoney: false,
                    theme: 'theme_row_blue',
                    keysSum: ['ventas_netas'],
                    keysSubtract: ['costos_directos'],
                    keyDivide: 'ventas_netas',
                    itemsDict: [],
                },
                "costos_fijos": {
                    label: 'Costos Fijos',
                    isMoney: true,
                    keysSum: ['costos_fijos'],
                    itemsDict: [],
                },
                "margen_contribucion": {
                    label: 'Margen Contribución',
                    isMoney: false,
                    theme: 'theme_row_azure',
                    keysSum: ['margen_contribucion'],
                    itemsDict: [],
                },
                "gastos_totales": {
                    label: 'Gastos Totales',
                    isMoney: true,
                    hasChilds: true,
                    keysSum: ['gastos_administracion', 'gastos_comerciales', 'gastos_i+d'],
                    itemsDict: [],
                },
                "gastos_administracion": {
                    label: 'Gastos Administración',
                    isMoney: true,
                    isShowed: false,
                    theme: 'nobreak theme_row_detail_bills ',
                    keysSum: ['gastos_administracion'],
                    itemsDict: [],
                },
                "gastos_comerciales": {
                    label: 'Gastos Comerciales',
                    isMoney: true,
                    isShowed: false,
                    theme: 'theme_row_detail_bills nobreak',
                    keysSum: ['gastos_comerciales'],
                    itemsDict: [],
                },
                "gastos_i+d": {
                    label: 'Gastos I+D',
                    isMoney: true,
                    isShowed: false,
                    theme: 'theme_row_detail_bills',
                    keysSum: ['gastos_i+d'],
                    itemsDict: [],
                },
                "gastos/ventas_%": {
                    label: 'Gastos/Ventas %',
                    isMoney: false,
                    theme: 'theme_row_yellow',
                    keysSum: ['gastos_administracion', 'gastos_comerciales', 'gastos_i+d'],
                    keyDivide: 'ventas_netas',
                    itemsDict: [],
                },
                "EBITDA": {
                    label: 'EBITDA',
                    isMoney: true,
                    keysSum: ['ventas_netas'],
                    keysSubtract: ['costos_directos', 'gastos_administracion', 'gastos_comerciales', 'gastos_i+d'],
                    itemsDict: [],
                },
                "margen_EBITDA_%": {
                    label: 'Margen EBITDA %',
                    isMoney: false,
                    theme: 'theme_row_purple',
                    keysSum: ['ventas_netas'],
                    keysSubtract: ['costos_directos', 'gastos_administracion', 'gastos_comerciales', 'gastos_i+d'],
                    keyDivide: 'ventas_netas',
                    itemsDict: [],
                },
                "no_operacional": {
                    label: 'No Operacional',
                    isMoney: true,
                    keysSum: ['ingresos_no_operacional'],
                    keysSubtract: ['gastos_no_operacional'],
                    itemsDict: [],
                },
                "ingresos_no_operacional": {
                    label: 'Ingresos No Operacional',
                    isMoney: true,
                    keysSum: ['ingresos_no_operacional'],
                    itemsDict: [],
                },
                "gastos_no_operacional": {
                    label: 'Gastos No Operacional',
                    isMoney: true,
                    keysSum: ['gastos_no_operacional'],
                    itemsDict: [],
                },
                "utilidad_antes_de_impuestos": {
                    label: 'Utilidad Antes de Impuestos',
                    isMoney: true,
                    keysSum: ['ventas_netas', 'ingresos_no_operacional'],
                    keysSubtract: ['costos_directos', 'gastos_administracion', 'gastos_comerciales', 'gastos_i+d', 'gastos_no_operacional'],
                    itemsDict: [],
                },
                "margen_neto_%": {
                    label: 'Margen Neto %',
                    isMoney: false,
                    theme: 'theme_row_orange',
                    keysSum: ['ventas_netas', 'ingresos_no_operacional'],
                    keysSubtract: ['costos_directos', 'gastos_administracion', 'gastos_comerciales', 'gastos_i+d', 'gastos_no_operacional'],
                    keyDivide: 'ventas_netas',
                    itemsDict: [],
                },
            },
            calculatedKeys: ['margen_bruto', 'gastos_totales', 'gastos/ventas_%',
                'EBITDA', 'margen_EBITDA_%', 'no_operacional', 'utilidad_antes_de_impuestos',
                'margen_neto_%'],
            periodTypes: [{ value: "lastYear", label: "Último año" },
            { value: "last24months", label: "Últimos 24 Meses" },
            { value: "actualYear", label: "Año Actual" },
            { value: "previousYear", label: "Año Anterior" },
            ],
            selectedPeriod: 'lastYear',
            allKeysOrdered: [],
            netSellsDetail: {},
            maxCostsDetail: {},
            maxExpensesDetail: {}
        };
    },
    props: {
    },
    mounted() {
        this.$nextTick(() => {
            this.getResultTableByPeriod()
        });
    },
    beforeDestroy() {
    },
    methods: {
        initStaticData() {
            this.allDetails = [{
                label: 'Crecimiento',
                value: '% MoM',
                theme: 'themePercentGreen',
                key: 'ventas_netas'
            }, {
                label: 'Margen Bruto',
                value: '%',
                theme: 'themePercentBlue',
                key: 'margen_bruto'
            }, {
                label: 'Eficiencia',
                value: '%',
                theme: 'themePercentOrange',
                key: 'gastos/ventas_%'
            }, {
                label: 'Margen EBITDA',
                value: '%',
                theme: 'themePercentPurple',
                key: 'margen_EBITDA_%'
            }]
            this.allSectionDetails = [
                [{
                    label: 'Ticket Promedio',
                    value: '$0',
                }, {
                    label: 'Cantidad de Clientes',
                    value: '0',
                }], [{
                    label: 'Cuenta',
                    value: '_',
                }, {
                    label: 'Contraparte',
                    value: '_',
                }], [{
                    label: 'Cuenta',
                    value: '_',
                }, {
                    label: 'Contraparte',
                    value: '_',
                }], [{
                    label: 'Antes de Impuestos',
                    value: '$0',
                }, {
                    label: 'Margen Neto %',
                    value: '0%',
                }],
            ]
        },
        calculateKey(keysSum, keysSubtract, keyDivide, columnHeader) {
            let sumAmount = 0
            keysSum.map(key => {
                if (!this.tableRowHeaders[key] || !this.tableRowHeaders[key].itemsDict || !this.tableRowHeaders[key].itemsDict[columnHeader]) {
                    return 0;
                }
                sumAmount += parseInt((this.tableRowHeaders[key] ?? {}).itemsDict[columnHeader] ?? 0);
            })

            let subtractAmount = 0
            keysSubtract.map(key => {
                if (!this.tableRowHeaders[key] || !this.tableRowHeaders[key].itemsDict || !this.tableRowHeaders[key].itemsDict[columnHeader]) {
                    return 0;
                }
                subtractAmount += parseInt((this.tableRowHeaders[key] ?? {}).itemsDict[columnHeader] ?? 0);
            })
            let divideAmount = 1
            if (keyDivide != '') {
                divideAmount = parseInt((this.tableRowHeaders[keyDivide]).itemsDict[columnHeader] ?? 0)
            }
            // Vuelve a comprobar el denominador
            if (divideAmount == 0) {
                return 0;
            }

            const calculatedAmount = ((sumAmount - subtractAmount) / divideAmount);
            return calculatedAmount;
        },
        changeViewTotalBills() {
            this.totalBillsExpanded = !this.totalBillsExpanded
            this.tableRowHeaders.gastos_totales.keysSum.map(key => {
                this.tableRowHeaders[key].isShowed = this.totalBillsExpanded
            })
        },
        money(value) {
            if (value == 0) {
                return '$0'
            }
            if (value != "") {
                return parseToMoney(value);
            }
        },
        getResultTableByPeriod() {
            this.initStaticData()
            const endDate = moment(this.endMonth).format('YYYY-MM-DD')
            let startDate = null
            let usedPeriod = this.filterPeriod
            switch (this.filterPeriod) {
                case 'month':
                    startDate = moment(this.endMonth).subtract(13, 'months')
                    break
                case 'quarter':
                    startDate = moment(this.endMonth).subtract(1, 'year').startOf('year')
                    break
                case 'ytd':
                    startDate = moment(this.endMonth).subtract(4, 'year').startOf('year')
                    // usedPeriod = 'year'
                    break
                case 'year':
                    startDate = moment(this.endMonth).subtract(4, 'year').startOf('year')
                    break
            }
            startDate = startDate.format('YYYY-MM-DD')
            getResultStateByPeriod(usedPeriod, startDate, endDate)
                .then(({ data }) => {
                    this.allKeysOrdered = data.all_keys
                    const allKeysFromDb = [...data.all_keys, 'gastos_no_operacional', 'ingresos_no_operacional']
                    allKeysFromDb.map(key => {
                        if (!this.tableRowHeaders[key]) {
                            this.tableRowHeaders[key] = {}
                        }
                        this.tableRowHeaders[key].items = data.report_data[key] ?? []
                        this.tableRowHeaders[key].itemsDict = {}
                        this.tableRowHeaders[key].items.map(item => {
                            let keyPeriod = this.passPeriodToHeader(item.period)
                            this.tableRowHeaders[key].itemsDict[keyPeriod] = item.total_amount
                        })
                    })
                    this.netSellsDetail = data.ventas_netas_detail
                    this.maxCostsDetail = data.max_costs_detail
                    this.maxExpensesDetail = data.max_expenses_detail
                }).then(() => {
                    this.scrollToRight()
                    let calculatedTable = JSON.parse(JSON.stringify(this.tableRowHeaders))

                    this.calculatedKeys.map(key => {
                        this.getHeadersTable().map(header => {
                            calculatedTable[key].itemsDict[header] = this.calculateKey(
                                calculatedTable[key].keysSum,
                                calculatedTable[key].keysSubtract ?? [],
                                calculatedTable[key].keyDivide ?? '',
                                header
                            )
                            if (!calculatedTable[key].isMoney) {
                                calculatedTable[key].itemsDict[header] = (calculatedTable[key].itemsDict[header] * 100).toFixed(2)
                            }
                        })
                    })
                    this.tableRowHeaders = JSON.parse(JSON.stringify(calculatedTable))
                    this.calculateCardsPercentAmounts()
                })
        },
        passPeriodToHeader(datePeriod) {
            let dateUsed = moment(datePeriod)
            switch (this.filterPeriod) {
                case 'month':
                    return dateUsed.format('MMM YYYY').replace('.', '')
                case 'quarter':
                    return 'Q' + dateUsed.quarter() + ' ' + dateUsed.year()
                case 'ytd':
                    return dateUsed.year()
                case 'year':
                    return dateUsed.year()
            }
        },
        changeDate() {
            this.getResultTableByPeriod()
        },
        getHeadersTable() {
            switch (this.filterPeriod) {
                case 'month':
                    return this.getMonthsName
                case 'quarter': {
                    const startDate = moment(this.endMonth).subtract(1, 'year').startOf('year')
                    let current = startDate.startOf('quarter');
                    const end = moment(this.endMonth).endOf('quarter');
                    const qs = [];
                    while (current.isSameOrBefore(end)) {
                        const quarterLabel = current.format('[Q]Q YYYY');
                        qs.push(quarterLabel);
                        current.add(1, 'quarter');
                    }
                    return qs;
                }
                case 'ytd': {
                    const actualYear = parseInt(moment(this.endMonth).format('YYYY'))
                    const years = [];
                    for (let i = 3; i >= 0; i--) {
                        years.push(actualYear - i);
                    }
                    return years
                }
                case 'year': {
                    const actualYear = parseInt(moment(this.endMonth).format('YYYY'))
                    const years = [];
                    for (let i = 3; i >= 0; i--) {
                        years.push(actualYear - i);
                    }
                    return years
                }
            }
        },
        calculateCardsPercentAmounts() {
            let ventasLabel = ''
            switch (this.filterPeriod) {
                case 'month':
                    ventasLabel = 'MoM'
                    break
                case 'quarter': {
                    ventasLabel = 'QoQ';
                    break
                }
                case 'ytd': {
                    ventasLabel = 'YoY'
                    break
                }
                case 'year': {
                    ventasLabel = 'YoY'
                    break
                }
            }
            this.allDetails = this.allDetails.map(det => {
                det.value = Math.round(
                    this.tableRowHeaders[det.key]?.itemsDict[this.getHeadersTable()[this.getHeadersTable().length - 1]] ?? 0
                ) + "%"
                if (det.key == 'ventas_netas') {
                    const numerator = this.tableRowHeaders[det.key]?.itemsDict[this.getHeadersTable()[this.getHeadersTable().length - 1]] ?? 0
                    const denominator = this.tableRowHeaders[det.key]?.itemsDict[this.getHeadersTable()[this.getHeadersTable().length - 2]] ?? 0
                    det.value = Math.round((numerator / denominator - 1) * 100) + '% ' + ventasLabel
                }
                return det
            })
            // Sells
            this.allSectionDetails[0][0].value = this.money(this.netSellsDetail.ticket_average)
            this.allSectionDetails[0][1].value = this.netSellsDetail.nro_counterparts

            // max Costs
            this.allSectionDetails[1][0].value = this.maxCostsDetail.max_cost_account
            this.allSectionDetails[1][1].value = this.maxCostsDetail.max_cost_counterpart

            // max expenses
            this.allSectionDetails[2][0].value = this.maxExpensesDetail.max_expenses_account
            this.allSectionDetails[2][1].value = this.maxExpensesDetail.max_expenses_counterpart

            // EBITDA
            const beforeTaxes = this.tableRowHeaders['utilidad_antes_de_impuestos']?.itemsDict[this.getHeadersTable()[this.getHeadersTable().length - 1]] ?? 0
            const netMarginPercent = this.tableRowHeaders['margen_neto_%']?.itemsDict[this.getHeadersTable()[this.getHeadersTable().length - 1]] ?? 0
            this.allSectionDetails[3][0].value = this.money(beforeTaxes)
            this.allSectionDetails[3][1].value = Math.round(netMarginPercent) + '%'

        },
        scrollToRight() {
            const container = this.$refs.mainTable;
            if (container) {
                container.scrollLeft = container.scrollWidth;
            }
        }
    },
    computed: {
        getMonthsName() {
            const months = [];
            let currentMonth = moment(this.endMonth);
            const monthsToSee = 13
            for (let i = 0; i < monthsToSee; i++) {
                let month = moment(this.endMonth).month(currentMonth.month() - monthsToSee + i + 1).format('MMM YYYY');
                month = month.replace('.', '')
                months.push(month);
            }
            return months;
        },
        getNow() {
            return moment().toDate()
        }
    },
    watch: {
        filterPeriod() {
            this.getResultTableByPeriod()
        },
    },
};
</script>

<style lang="scss" scoped>
* {
    font-family: Inter;
}

.ecsFilter {
    height: 20px;
    overflow: hidden;
    flex-shrink: 0;
    margin-bottom: -5px;
}

.headerTop {
    position: sticky;
    top: 110px;
    width: 100%;
    background-color: white;
    z-index: 5;
    border-bottom: 1px solid #EAECF0;
}

.underHeader {
    position: relative;
}


.main_div {
    padding-left: clamp(10px, 5.5vw, 90px);
    padding-right: clamp(10px, 5.5vw, 93px);
    padding-bottom: 30px;
}


.header_section_header {
    padding-top: 30px;
    justify-content: space-between;
}

.header_title {
    font-size: 1.5em;
    font-weight: bold;
    margin-bottom: 5px;
}

.header_description {
    font-size: 1em;
    color: gray;
}

.filter_container {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    gap: 0;
    flex: 2;
}

$select_transition: 0.1s;

.select_button {
    text-align: center;
    border-radius: 0;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    border-right: 0.5px solid #ccc;
    border-left: 0.5px solid #ccc;
    margin: 0;
    padding: clamp(5px, 6px, 8px) clamp(10px, 12px, 16px);
    background-color: #ffffff;
    color: #000000;
    transition: all $select_transition ease;
}

.select_button:hover {
    background-color: #c7c7c7;
    color: #000000;
    transition: all $select_transition ease;
}

.select_button:first-of-type {
    border-left: 1px solid #ccc;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
}

.select_button:last-of-type {
    border-right: 1px solid #ccc;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
}

.black_button {
    background-color: #002e33 !important;
    color: #ffffff !important;
    transition: all $select_transition ease;
}

.black_button:hover {
    background-color: #185555 !important;
    color: #ffffff !important;
    transition: all $select_transition ease;
}

@mixin theme-button($background-color, $border-color, $color-text) {
    border-radius: 8px;
    background-color: $background-color;
    color: $color-text;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    border: 1px solid $border-color;
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
    padding: 10px 14px;
    justify-content: center;
    align-items: center;
}

.theme_btn_dark {
    @include theme-button(#002E33, #002E33, white);
}

.theme_btn_white {
    @include theme-button(white, #EBEBEB, black);
}

.has-gap-cards {
    gap: 20px;
}

.tittle_section {
    color: var(--text-strong-950, #171717);
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: -0.176px;
}

.filter_section {
    height: 30px;
    padding-inline: 10px;
    text-align: center;
    vertical-align: middle;
    align-items: center;
    border-radius: var(--radius-10, 10px);
    border: 1px solid var(--stroke-soft-200, #EBEBEB);
    background: var(--bg-white-0, #FFF);
    box-shadow: 0 1px 2px 0 rgba(10, 13, 20, 0.03);

    color: #5C5C5C;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: -0.084px;
}

.container_section {
    border-radius: var(--radius-16, 16px);
    border: 1px solid var(--stroke-soft-200, #EBEBEB);
    background: var(--bg-white-0, #FFF);

    /* regular-shadow/x-small */
    box-shadow: 0 1px 2px 0 rgba(10, 13, 20, 0.03);
}

.table-container {
    overflow-x: auto;
}

.sticky-column {
    position: sticky;
    left: 0;
    z-index: 1;
    //   background-color: white; 
}

.custom_table {
    table-layout: fixed;

    td,
    th {
        height: 44px;
        padding: 12px 16px !important;

        border-bottom: 1px solid var(--Gray-200, #EAECF0);
        vertical-align: middle;
    }

    thead th,
    td {
        text-align: end;
    }

    thead th {
        padding: 12px 24px;
        align-items: center;
        align-self: stretch;
        color: var(--Gray-600, #475467);
        font-size: 12px;
        font-weight: 700;
        line-height: 18px;
    }

    tbody th {
        color: var(--Gray-900, #101828);
        font-size: 12px;
        font-weight: 500;
        line-height: 18px;
    }

    tbody td {
        color: var(--Gray-600, #475467);
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
    }

    .theme_row_white {
        background-color: white;
    }

    .theme_row_header {
        background-color: #EAECF0;
    }

    .theme_row_blue {
        background-color: #D9E3FF;
    }

    .theme_row_azure {
        background-color: #D2F9FB;
    }

    .theme_row_yellow {
        background-color: #FEF189;
    }

    .theme_row_purple {
        background-color: #DBD6FE;
    }

    .theme_row_orange {
        background-color: #F2EFDC;
    }

    .theme_row_detail_bills {
        padding-left: 3em !important;
        border-bottom: 1px solid var(--Gray-200, #EAECF0);
        background: #FEFCE8;
    }
}

.actual_button_arrow_down {
    flex-shrink: 0;
    -ms-flex-align: end;
    align-self: center;
    vertical-align: middle;
    width: 18px;
    height: 18px;
    // padding-top: 4px;
}

.color_arrow {
    filter: brightness(0) saturate(100%) invert(6%) sepia(55%) saturate(756%) hue-rotate(181deg) brightness(92%) contrast(94%);
}

.rotate_arrow {
    transform: rotate(180deg);
}
</style>
